import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { I18N, GlobalContext } from 'commons';
import FieldErrorMessage from '../FieldErrorMessage';

const ExternalIdSection = ({
  onChange,
  onBlur,
  errors,
  externalId,
  touched,
}) => {
  const { organization: { externalIDSetting = {} } } = useContext(GlobalContext);
  const externalIdHasError = _.has(errors, 'externalId');
  const externalIdHasTouched = _.has(touched, 'externalId');
  const { externalIDMandatory } = externalIDSetting;
  const externalIDEditable = externalIDSetting.editExternalID;
  const externalIDExposed = externalIDSetting.exposeExternalID;

  return (
    <div className="form-group row">
      {externalIDExposed && (
        <div className="col-md-12">
          <label id="externalIdLabel" htmlFor="externalId">

            <I18N>ssp.profile.external.id</I18N>
            {
              externalIDMandatory &&
              <span aria-hidden="true" className="required-star">*</span>
            }
            {
              externalIDMandatory &&
              <span className="sr-only"><I18N>information.label.required</I18N></span>
            }
          </label>
          <Field
            autoComplete="off"
            type="text"
            id="externalId"
            className="form-control"
            name="externalId"
            maxLength="50"
            value={externalId}
            onChange={onChange}
            onBlur={onBlur}
            disabled={!externalIDEditable}
            aria-invalid={externalIdHasTouched && externalIdHasError}
            aria-describedby={(externalIdHasError && externalIdHasTouched) ? 'externalIdDesc' : null}
          />
          {externalIdHasError && externalIdHasTouched && (
            <FieldErrorMessage id="externalIdDesc" role="alert">
              <I18N>{errors.externalId}</I18N>
            </FieldErrorMessage>
          )}
        </div>
      )}
    </div>
  );
};

ExternalIdSection.propTypes = {
  externalId: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errors: PropTypes.shape(),
};

ExternalIdSection.defaultProps = {
  externalId: '',
  errors: {},
  onChange: () => { },
  onBlur: () => { },
};

export default ExternalIdSection;
